import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from "@angular/material/dialog";
import { appSettingService } from './appSettings.service';
import { APIConfigMapping } from "../vl-http/api-mapping-config.cnst";
import { HTTPAPIConfig } from "../vl-http/http-api.config";
import { VlDataService } from "../vl-data/vl-data.service";
import { VlHttpService } from "../vl-http/vl-http.service";
import { ImageCropperComponent } from '../shared_components/image-cropper/image-cropper.component';
import { isNullOrUndefined } from '../vl_util_functions/common-utils';
@Component({
  selector: 'lib-web-settings',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.scss']
})
export class AppSettingsComponent {

  applicationId!: string;
  applicationData: any = {};
  biometrics: boolean = false;
  isChecked: boolean = false;
  showImageLengthError: boolean = false;
  selectedImage!: File | any;
  imageSrc!: any;
  applicationName!: string;
  applicationDescription!: string;
  imageS3Key: any;
  timeStampEnabled: boolean = false;
  lastModifiedDate: any;

  constructor(private dataService: VlDataService, private toaster: ToastrService, private dialog: MatDialog, private httpService: VlHttpService, private route: ActivatedRoute, private appDetailsService: appSettingService) {
    this.subscribeEvents();
  }


  subscribeEvents() {
    this.route.queryParams.subscribe((params: Params) => {
      this.getApplicationById(params?.['id']);
      this.applicationId = params?.['id']
    })
  }



  getApplicationById(id: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_APPLICATION']);
    apiConfig.postData = {
      id: id
    }
     apiConfig.options = {
      params: {
        "is_web":"true",
      }
    }
    let appdetails = this.appDetailsService.getApplicationDetails()
    if(!isNullOrUndefined(appdetails)){
      this.applicationData = appdetails;
      this.applicationName = appdetails.application_name;
      this.biometrics = appdetails.biometric;
      this.applicationDescription = appdetails.application_description;
      this.imageS3Key = appdetails?.image
      this.imageSrc = appdetails?.image;
      this.timeStampEnabled = true;
      this.lastModifiedDate = appdetails?.last_modified_date
    }else{
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.appDetailsService.setApplicationDetails(data);
        this.applicationData = data;
        this.applicationName = data.application_name;
        this.biometrics = data.biometric;
        this.applicationDescription = data.application_description;
        this.imageS3Key = data?.image
        this.imageSrc = data?.image;
        this.timeStampEnabled = true;
        this.lastModifiedDate = data?.last_modified_date
      },
      error: (err: any) => {
      }
    })}
  }

  onToggleChange(event: any) {
    this.isChecked = event.checked;
  }

  onFileSelected(event: any) {
    this.timeStampEnabled = false;
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      this.openCropper(selectedFile);
    }
  }

  editApplication(applicationName: string, applicationDescription: string, applicationIcon: File, applicationId: string, biometrics: boolean) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['EDIT_APPLICATION']);
    let userInfoString: any = localStorage.getItem('userInfo');
    if (userInfoString !== null) {
      const userInfo = JSON.parse(userInfoString);
      const userId = userInfo.userId;
    }
    apiConfig.postData = {
      application_id: applicationId,
      application_name: applicationName,
      application_description: applicationDescription,
      biometric: biometrics,
      last_modified_by: "User2"
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        const applicationData = this.appDetailsService.getApplicationDetails();
        applicationData.application_description = applicationDescription;
        applicationData.application_name = applicationName;
        this.appDetailsService.setApplicationDetails(applicationData);   
      },
      error: (err: any) => {
      }
    })
  }

  editApplicationLogo(icon: File, applicationId: string) {

    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['EDIT_APPLICATION_LOGO']);
    let userInfoString: any = localStorage.getItem('userInfo');
    let userId;
    if (userInfoString !== null) {
      const userInfo = JSON.parse(userInfoString);

      userId = userInfo.userId;
    }
    apiConfig.postData = {
      user_id: userId,
      application_id: applicationId,
      image: icon,
      key: this.imageS3Key?.split("/")?.pop()
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        const applicationData = this.appDetailsService.getApplicationDetails();
        applicationData.last_modified_date=new Date().toLocaleTimeString('en-US', { hour12: false });
        applicationData.image = this.imageSrc;
        this.appDetailsService.setApplicationDetails(applicationData);   
      },
      complete: () => {
        this.selectedImage = null;
      },
      error: (err: any) => {
        this.toaster.error("Somthing went wrong , please try after someting or use a different image type");
      }
    })
  }

  onCancelClick() {

  }

  onSaveClick() {
    if (this.applicationData.application_name !== this.applicationName || this.applicationData.application_description !== this.applicationDescription || this.applicationData.biometric !== this.biometrics) {
      this.editApplication(this.applicationName, this.applicationDescription, this.selectedImage, this.applicationId, this.biometrics);
    }
    if (this.selectedImage != null) {
      this.editApplicationLogo(this.selectedImage, this.applicationId);
    }

  }

  openCropper(selectedimage: File) {
    const dialogRef = this.dialog.open(ImageCropperComponent, {
      disableClose: true,
      data: {
        imageFile: selectedimage
      }
    })

    dialogRef.afterClosed().subscribe(result => {

      if (typeof (result) !== 'boolean' && result !== undefined) {

        this.imageSrc = result.croppedImageUrl,
          this.selectedImage = result.croppedImageFile
      }
    });
  }
}